export default __webpack_public_path__ + "static/media/search.8949b2a4.svg";